import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PageSubheaderBarConfig } from '../../../fw/pages/page-config-api';
import { FormService } from '../../../fw/services/form.service';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsCashregService} from "./settings-cashreg.service";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DtoTreatmentForCombi} from "./models/DtoTreatmentForCombi";
import {ValidationMessageComponent} from "../../shared/validation-message.component";

@Component({
    selector: 'curecredit-treatment-search',
    template: require('./curecredit-treatment-search.component.html'),
    styles: [require('./curecredit-treatment-search.component.css')]
})
@AutoUnsubscribe()

export class CurecreditTreatmentSearchComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Output() treatmentChosen = new EventEmitter<DtoTreatmentForCombi>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    pageSubheaderBarConfig: PageSubheaderBarConfig;
    formSearch: FormGroup;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '110px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPrice',
            label: 'Prijs',
            type: 'number',
            width: '100px',
            format: '{0:c}'
        }
    ];
    selectedTreatment: DtoTreatmentForCombi;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService) { }

    ngOnInit() {
        this.pageSubheaderBarConfig = {
            title: 'BEHANDELING',
            buttonDefinition: [
                {
                    clickEventType: 'choose',
                    description: 'KIEZEN',
                    isSmall: true
                },
                {
                    clickEventType: 'cancel',
                    description: 'ANNULEREN',
                    isSmall: true
                }
            ]
        };

        this.formSearch = this.fb.group({
            description: [''],
            index: [null]
        });
    }

    btnClearClicked(event) {
        this.formSearch.reset();
        this.grid.showData([]);
    }

    btnSearchClicked(event) {
        this.ds.getTreatmentForCombi({
            description: this.formSearch.value.description,
            index: this.formSearch.value.index
        }).subscribe(res => {
            this.grid.showData(res);
        });
    }

    btnSubHeaderBarClicked(event) {
        if (event == 'choose') {
            if (this.selectedTreatment) {
                this.treatmentChosen.emit(this.selectedTreatment);
                this.closeWindow(false);
            }
        } else if (event == 'cancel') {
            this.closeWindow(false);
        }
    }

    rowDoubleClicked(event) {
        let chosenItem = this.grid.getSelectedItem();
        if (chosenItem) {
            this.treatmentChosen.emit(chosenItem);
            this.closeWindow(false);
        }
    }

    gridSelectionChanged(event: DtoTreatmentForCombi) {
        this.selectedTreatment = event;
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/curecredit-treatment-search.component.ts